module.exports = {
          srcSet: __webpack_public_path__ + "images/2019-544c9879ae61563850e39b28d4cbd89a-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2019-5f0c695dd7b2f76b3a311e088f603f2e-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2019-544c9879ae61563850e39b28d4cbd89a-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2019-5f0c695dd7b2f76b3a311e088f603f2e-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2019-544c9879ae61563850e39b28d4cbd89a-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2019-544c9879ae61563850e39b28d4cbd89a-320.jpg"},
          
          width: 320,
          height: 251
        }